import { Injectable } from '@angular/core'
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router'
import { TokenService } from './token.service'
import { Observable } from 'rxjs'
import { Router } from '@angular/router'
import { LocalStorageService } from './local-storage.service'
import { SnotifyService } from 'ng-snotify'


@Injectable({
    providedIn: 'root'
})
export class AfterLoginService implements CanActivate {

    constructor(
        private tokenService: TokenService,
        private router: Router,
        private localStorageService: LocalStorageService,
        private notify: SnotifyService
    ) {

    }

    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): boolean | Observable<boolean> | Promise<boolean> {
        if (!this.tokenService.loggedIn()) {
            this.router.navigateByUrl('/login')
            return false
        }
        return true
    }
}
